import { IGradualIncreaseHelperParams, IGradualIncreaseHelper } from "./gradual-increase-helper.interface";

interface GradualIncreaseHelperCompleteParams extends IGradualIncreaseHelperParams {
    frequency: number;
}

export class GradualIncreaseHelper implements IGradualIncreaseHelper {
    private params: GradualIncreaseHelperCompleteParams;

    private previousUpdateTime: number | undefined;
    private realAmount: number = 0;
    private fakeAmount: number = 0;
    private stepAmount: number = 0;

    private amountIncreaseTimer: number | undefined;

    constructor(_params: IGradualIncreaseHelperParams) {
        this.params = {
            frequency: 1000,
            ..._params,
        };
    }

    public restart(){
        this.realAmount = 0;
        this.previousUpdateTime = undefined;
        this.stopAmountIncreaseTimer();
    }

    public updateAmount(amount: number, previousUpdateTime?: number, startAmount?: number) {
        if(!this.realAmount) {
            this.realAmount = startAmount;
        }

        if(!this.previousUpdateTime) {
            this.previousUpdateTime = previousUpdateTime;
        }

        // As a safety net, when this function is called with an argument lower than the current amount, just ignore
        // It shouldn't happen.
        if(amount <= this.realAmount) {
            return;
        }

        // stop the previous timer (interval)
        this.stopAmountIncreaseTimer();

        // calculate number of steps
        const interval = this.params.interval || (Date.now() - this.previousUpdateTime) + 5000; // add 5 seconds to prevent uneven amount update intervals
        const steps = interval / this.params.frequency;

        // calculate step amount
        this.stepAmount = (amount - this.realAmount) / steps;

        // update amount with the previous real amount
        this.params.updateAmountFunction(this.realAmount);

        this.fakeAmount = this.realAmount;

        this.realAmount = amount;
        this.previousUpdateTime = Date.now();

        // start timer
        this.startAmountIncreaseTimer();
    }

    private updateFakeAmount() {
        this.fakeAmount = this.fakeAmount + this.stepAmount;
        if (this.fakeAmount <= this.realAmount) {
            this.params.updateAmountFunction(this.fakeAmount);
        } else {
            if ((this.fakeAmount - this.realAmount) < this.stepAmount) {
                this.params.updateAmountFunction(this.realAmount);
            }
        }
    }

    private stopAmountIncreaseTimer(){
        if (this.amountIncreaseTimer){
          clearInterval(this.amountIncreaseTimer);
          this.amountIncreaseTimer = undefined;
        }
      }

    private startAmountIncreaseTimer() {
        this.amountIncreaseTimer = setInterval(() => {
            this.updateFakeAmount();
        }, this.params.frequency);
    }
}
